"use client";

import { useEffect, useState } from "react";

// Distance (px) between the layout and visual viewport heights above which we
// treat the on-screen keyboard as open. Keeps browser toolbar collapse/expand
// (typically < 120px) from being mistaken for a keyboard.
const KEYBOARD_HEIGHT_THRESHOLD = 150;

/**
 * Detects the mobile on-screen (virtual) keyboard via the VisualViewport API.
 * When the keyboard opens, the visual viewport shrinks well below the layout
 * viewport height. Returns `false` when the API is unavailable (e.g. SSR,
 * desktop) so callers keep their default behaviour.
 */
export const useKeyboardOpen = () => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;

    const handleResize = () => {
      setIsKeyboardOpen(
        window.innerHeight - viewport.height > KEYBOARD_HEIGHT_THRESHOLD
      );
    };

    handleResize();
    viewport.addEventListener("resize", handleResize);

    return () => viewport.removeEventListener("resize", handleResize);
  }, []);

  return isKeyboardOpen;
};
